import { useState } from 'react';

import { CONTENT_CONSTANTS, IContent } from '@_entities/content';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { SingleInputFormPopup } from '@_shared/ui/Popup';
import { Typography } from '@_shared/ui/Typography';

import { useContentAction } from '../../hooks';

import * as S from './ContentTitleEditPopup.style';

interface Props {
	content: IContent;
	contentTitle: string;
}

export function ContentTitleEditPopup({ content, contentTitle }: Props) {
	const { popLayer } = useUILayerStore();
	const { dispatch } = useContentAction(content);

	const [titleInputValue, setTitleInputValue] = useState(contentTitle);

	function isSubmitDisabled() {
		return titleInputValue.length === 0 || titleInputValue === contentTitle;
	}

	return (
		<SingleInputFormPopup.Container closePopup={popLayer}>
			<SingleInputFormPopup.TextContainer>
				<SingleInputFormPopup.Title>제목</SingleInputFormPopup.Title>
				<SingleInputFormPopup.Button
					disabled={isSubmitDisabled()}
					onClick={() => {
						dispatch({
							type: 'UPDATE_TITLE',
							title: titleInputValue,
						});
						popLayer();
						popLayer();
					}}
				>
					<Typography
						type="title-small"
						color={isSubmitDisabled() ? 'warmgray-400' : 'orange-primary'}
					>
						저장
					</Typography>
				</SingleInputFormPopup.Button>
			</SingleInputFormPopup.TextContainer>
			<S.TextArea
				defaultValue={contentTitle}
				placeholder="제목을 입력해주세요"
				onChange={(e) => {
					e.preventDefault();
					setTitleInputValue(e.target.value);
				}}
				maxLength={CONTENT_CONSTANTS.TITLE_MAX_LENGTH}
			/>
			<S.TextAreaCounter>
				<Typography
					type="label-large"
					color="warmgray-400"
				>{`${titleInputValue.length} / ${CONTENT_CONSTANTS.TITLE_MAX_LENGTH}`}</Typography>
			</S.TextAreaCounter>
		</SingleInputFormPopup.Container>
	);
}
